<template>
    <div class="report-arrears">
        <div class="totle-content">
            <div class="select-search">
                <div class="select-group">


                </div>
                <div class="button-group">
                    <!--<el-button type="primary" icon="el-icon-search" @click="occupancyrate">搜索</el-button>-->
                    <el-button type="success" icon="el-icon-tickets" @click="downloadMater">导出</el-button>
                </div>

            </div>

            <div class="table-content">
                <el-table class="table-head" :data="arrearsData" border>
                    <el-table-column align="center" type="index" width="50"></el-table-column>
                    <el-table-column align="center" prop="title" label="名称"></el-table-column>
                    <el-table-column align="center" prop="ccode" label="集中器编码"></el-table-column>
                    <el-table-column align="center" prop="pcode" label="设备编码"></el-table-column>
                    <el-table-column align="center" prop="addr" label="地址" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" prop="name" label="姓名"></el-table-column>
                    <el-table-column align="center" prop="surplus" label="欠费（度）"></el-table-column>
                    <el-table-column align="center" prop="price" label="电价（元）"></el-table-column>
                    <el-table-column align="center" prop="staydate" label="入住时间" show-overflow-tooltip></el-table-column>
                    <!--<el-table-column align="center" prop="staydate" label="操作" min-width="50">-->
                        <!--<template slot-scope="scope">-->
                            <!--<el-button @click="toHouse(scope.$index, arrearsData)" type="text" size="small">查看</el-button>-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                </el-table>
            </div>

        </div>
    </div>
</template>

<script>
    import store from "../store";
    var FileSaver = require('file-saver');

    export default {
        name: "ReportArrears",
        data() {
            return{
                arrearsData:[],


            }
        },
        mounted(){

                this.$http.get(`${store.state.url}report/arrears/all?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                      if (res.Code == 0) {
                        let arrearsData=[];
                        if(res.Data!=null) {
                            for (let i in res.Data) {
                                arrearsData[i] = {
                                    title: res.Data[i].title,
                                    ccode: res.Data[i].ccode,
                                    pcode: res.Data[i].pcode,
                                    addr: res.Data[i].addr,
                                    name: res.Data[i].name,
                                    surplus: res.Data[i].surplus,
                                    price: res.Data[i].price,
                                    staydate: res.Data[i].staydate,
                                    devid: res.Data[i].Uuid,
                                }
                            }
                        }
                        this.arrearsData=arrearsData;
                      } else {
                        this.arrearsData=[];
                        this.$message(res.Message);
                      }
                    })

        },
        methods:{
            //导出excel
            downloadMater (){
                const defaultCellStyle =  { font: { name: "Verdana", sz: 11, color: "FF00FF88"}, fill: {fgColor: {rgb: "FFFFAA00"}}};
                const wopts = { bookType:'xlsx', bookSST:false, type:'binary', defaultCellStyle: defaultCellStyle, showGridLines: false};
                const wb = { SheetNames: ['Sheet1'], Sheets: {}, Props: {} };

                let Data=[];
                for(let i in this.arrearsData){
                    Data[i] = {
                        名称: this.arrearsData[i].title,
                        集中器编码: this.arrearsData[i].ccode,
                        设备编码: this.arrearsData[i].pcode,
                        地址: this.arrearsData[i].addr,
                        姓名: this.arrearsData[i].name,
                        欠费度数: this.arrearsData[i].surplus,
                        电价: this.arrearsData[i].price,
                        入住时间: this.arrearsData[i].staydate,
                    };
                }
                let data = Data;
                wb.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(data);

                //创建二进制对象写入转换好的字节流
                let tmpDown =  new Blob([this.s2ab(XLSX.write(wb, wopts))], { type: "application/octet-stream" })
                FileSaver.saveAs(tmpDown, "异常电表.xls");
            },
            //字符串转字符流
            s2ab (s) {
                if (typeof ArrayBuffer !== 'undefined') {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                } else {
                    var buf = new Array(s.length);
                    for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                }
            },

            toHouse(index, row) {
                let devid = row[index].devid,
                    tableInfo = {};
                window.localStorage.devid = devid;
                tableInfo.table = 1;
                tableInfo.index = '4';
                store.commit('assignReportPreTableTab', tableInfo);
                this.$router.push('./house');
            }
        }
    }
</script>

<style scoped>
.button-group{
    margin-right:5px;
}

</style>
